angular.module("screensApp").controller("BannersController", function ($scope, $rootScope, $timeout) {
  var customBannerActive = false;

  /**
   * New listing throught banners
   */
  $rootScope.bannersListing = function () {
    $timeout.cancel($rootScope.bannersListingInterval);

    if (!$rootScope.banners || $rootScope.banners.length == 0) {
      // Banners Callback
      $timeout($rootScope.bannersListing, 1000);
      return;
    }

    // Actual banner
    if (isActual($rootScope.banners[$rootScope.slideIndex])) {
      if ($rootScope.banners.length == 1) var prev = false;
      else var prev = prevIndex($rootScope.slideIndex);

      if (prev != false) {
        $rootScope.banners[prev].show = true; // Show previous slide
      }
      $rootScope.banners[$rootScope.slideIndex].show = true; // Set actual slide

      if (prev != false) {
        $rootScope.banners[prev].show = false; // Hide previous slide
      }

      var duration = $rootScope.banners[$rootScope.slideIndex].Duration * 1000; // Set duration (convert to ms)
      if (!duration) duration = 10000;

      // Visual elements are controller by a custom banner now
      if (!customBannerActive) {
        // Don't display winners defined countries
        if ($rootScope.bannedCountriesForWinners.indexOf($rootScope.config.Country) != -1) {
          $rootScope.settings.winnersForBanner = false;
        } else {
          $rootScope.settings.winnersForBanner = $rootScope.banners[$rootScope.slideIndex].ShowWinners;
        }

        // 18+
        $rootScope.settings.limitAge = $rootScope.banners[$rootScope.slideIndex].LimitAge;
      }
    }
    // Non-actual banner
    else {
      $rootScope.slideIndex = $rootScope.slideIndex == $rootScope.banners.length - 1 ? 0 : ++$rootScope.slideIndex;
      $rootScope.bannersListing();
      return;
    }

    // Hide other banners
    angular.forEach($rootScope.banners, function (banner, index) {
      if (index != $rootScope.slideIndex) {
        banner.show = false;
      }
    });

    // List callback
    if ($rootScope.banners.length > 1) {
      $rootScope.slideIndex = $rootScope.slideIndex == $rootScope.banners.length - 1 ? 0 : ++$rootScope.slideIndex; // Set index
      $rootScope.bannersListingInterval = $timeout($rootScope.bannersListing, duration);
    }
  };

  /**
   * List throught custom banners
   */
  $rootScope.customBannersListing = function () {
    $timeout.cancel($rootScope.custombannersListingInterval);

    if (!$rootScope.customBanners || $rootScope.customBanners.length == 0) {
      // Banners Callback
      $timeout($rootScope.customBannersListing, 1000);
      return;
    }

    // Actual banner
    if (isActual($rootScope.customBanners[$rootScope.slideCustomIndex])) {
      customBannerActive = true;

      if ($rootScope.customBanners.length == 1) var prev = false;
      else var prev = prevIndex($rootScope.slideCustomIndex, true);

      if (prev !== false) {
        $rootScope.customBanners[prev].show = true; // Show previous slide
        if ($rootScope.customBanners[prev].IsJackpot) {
          $rootScope.hideJackpotContainer(false);
        }
      }
      $rootScope.customBanners[$rootScope.slideCustomIndex].show = true; // Set actual slide
      if ($rootScope.customBanners[$rootScope.slideCustomIndex].IsVideo) {
        listenTopScreen("video", $rootScope.customBanners[$rootScope.slideCustomIndex]);
        $rootScope.settings.video.show = true;
        $rootScope.$$phase || $rootScope.$apply();
      } if ($rootScope.customBanners[$rootScope.slideCustomIndex].IsJackpot) {
        $rootScope.determineJackpotRender();
      }

      if (prev !== false) {
        $rootScope.customBanners[prev].show = false; // Hide previous slide
        if ($rootScope.customBanners[prev].IsVideo && !$rootScope.customBanners[$rootScope.slideCustomIndex].IsVideo) $rootScope.hideVideo();
        if ($rootScope.customBanners[prev].IsJackpot) $rootScope.hideJackpotContainer(false);
      }

      var duration = $rootScope.customBanners[$rootScope.slideCustomIndex].Duration * 1000; // Set duration (convert to ms)
      if (!duration) duration = 10000;

      // Don't display winners defined countries
      if ($rootScope.bannedCountriesForWinners.indexOf($rootScope.config.Country) != -1) {
        $rootScope.settings.winnersForBanner = false;
      } else {
        $rootScope.settings.winnersForBanner = $rootScope.customBanners[$rootScope.slideCustomIndex].ShowWinners;
      }

      // 18+
      $rootScope.settings.limitAge = $rootScope.customBanners[$rootScope.slideCustomIndex].LimitAge;
    }
    // Non-actual banner
    else {
      customBannerActive = false;
      $rootScope.slideCustomIndex = $rootScope.slideCustomIndex == $rootScope.customBanners.length - 1 ? 0 : ++$rootScope.slideCustomIndex;
      $rootScope.customBannersListing();
      return;
    }

    // Hide other banners
    angular.forEach($rootScope.customBanners, function (banner, index) {
      if (index != $rootScope.slideCustomIndex) {
        banner.show = false;
      }
    });

    // List callback
    if ($rootScope.customBanners.length > 1) {
      $rootScope.slideCustomIndex = $rootScope.slideCustomIndex == $rootScope.customBanners.length - 1 ? 0 : ++$rootScope.slideCustomIndex; // Set index
      $rootScope.custombannersListingInterval = $timeout($rootScope.customBannersListing, duration);
    }
  };

  /**
   * @param dateXML
   * @returns {*}
   */
  $rootScope.parseDate = function (dateXML) {
    if (!dateXML) return false;
    var origin = dateXML.split("."),
      switched = origin[1] + "." + origin[0] + "." + origin[2];
    return new Date(switched);
  };

  /**
   * Check whether banner is actual
   *
   * @param banner
   * @returns {boolean}
   */
  function isActual(banner) {
    if (banner.IsJackpot) {
      // Jackpot has permanent validity
      return true;
    }
    var timestamp = moment().valueOf() - $rootScope.timeDiff,
      now = moment(timestamp).valueOf(),
      start = moment(banner.Start).valueOf(),
      end = moment(banner.End).valueOf();

    return start <= now && end >= now;

    //if (start > now || end < now) return false;
    //else return true;
  }

  /**
   * Get previous index of array
   * @param index
   * @returns {number}
   */
  function prevIndex(index, custom) {
    var length = custom ? $rootScope.customBanners.length : $rootScope.banners.length;
    return index == 0 ? length - 1 : index - 1;
  }
});
